import axios from "axios";

const API_URL = process.env.REACT_APP_API_Link;

const loginUser = (values) => {
  return axios.post(
    API_URL + "login",
    {
      email: values.username,
      password: values.password,
      device_name: "web",
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  );
};

const recoverUser = (values) => {
  return axios.post(
    API_URL + "forgot-password",
    {
      email: values.username,
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  );
};

const checkResetLink = (token, emailValue) => {
  return axios.post(
    API_URL + "validate-reset-password-token",
    {
      token: token,
      email: emailValue,
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  );
};

const setNewPassword = (values, token, emailValue) => {
  return axios.post(
    API_URL + "reset-password",
    {
      token: token,
      email: emailValue,
      password: values.password,
      password_confirmation: values.con_password,
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  );
};

const getCategory = (token, values = {}) => {
  return axios.get(
    API_URL +
      `category${
        values?.column && values?.search
          ? `?${values?.column}=${values?.search}`
          : ""
      }`,
    {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
  );
};

const exportCategory = (token, values = {}, ids) => {
  return axios.get(
    API_URL +
      `category?ids=${ids}&all=1${
        values.column && values.search && !ids
          ? `&${values.column}=${values.search}`
          : ""
      }`,
    {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
  );
};

const addUsers = (values, selectedOptions, token) => {
  return axios.post(
    API_URL + "user",
    {
      first_name: values.fname,
      last_name: values.lname,
      email: values.email,
      role: values.role === "admin" ? values.role : "",
      // password: values.password,
      // password_confirmation: values.con_password,
      categories: selectedOptions.join(","),
    },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
  );
};
const getUsers = (token, page, limit, values) => {
  return axios.get(
    API_URL +
      `user?limit=${limit}&page=${page}${
        values.column && values.search
          ? `&${values.column}=${values.search}`
          : ""
      }`,
    {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
  );
};
const exportUsers = (token, ids, values) => {
  return axios.get(
    API_URL +
      `user?ids=${ids}&all=1${
        values.column && values.search && !ids
          ? `&${values.column}=${values.search}`
          : ""
      }`,
    {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
  );
};
const getUsersById = (id, token) => {
  return axios.get(API_URL + "user/" + id, {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

const deleteUsersById = (token, id) => {
  return axios.delete(API_URL + "user/" + id, {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

const updateUser = (values, selectedOptions, id, token) => {
  return axios.put(
    API_URL + "user/" + id,
    {
      first_name: values.fname,
      last_name: values.lname,
      email: values.email,
      role: values.role,

      categories: selectedOptions?.join(","),
    },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
  );
};

const updateProfile = (values, id, token) => {
  return axios.put(
    API_URL + "user/" + id,
    {
      first_name: values.fname,
      last_name: values.lname,
      email: values.email,
      // password: values.password,
      // password_confirmation: values.con_password,
    },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
  );
};

const putFile = (values, token) => {
  return axios.post(API_URL + "file", values, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  });
};
// const getFiles = (cat, user, token, page, limit, values) => {
//   return axios.get(
//     cat
//       ? `${API_URL}files/${cat}?limit=${limit}&page=${page}&category_id=${
//           values?.category || ""
//         }&date=${values?.date || ""}${
//           values.column && values.search
//             ? `&${values.column}=${values.search}`
//             : ""
//         }`
//       : `${API_URL}files?limit=${limit}&page=${page}&category_id=${
//           values?.category || ""
//         }&date=${values?.date || ""}${
//           values.column && values.search
//             ? `&${values.column}=${values.search}`
//             : ""
//         }`,
//     {
//       headers: {
//         "Content-Type": "application/json",
//         Accept: "application/json",
//         Authorization: `Bearer ${token}`,
//       },
//     }
//   );
// };
const getFiles = (cat, user, token, page, limit, values) => {
  return axios.get(
    cat
      ? `${API_URL}files/${cat}?limit=${limit}&page=${page}${
          values.column && values.search
            ? `&${values.column}=${values.search}`
            : ""
        }`
      : `${API_URL}files?limit=${limit}&page=${page}${
          values.column && values.search
            ? `&${values.column}=${values.search}`
            : ""
        }`,
    {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
  );
};

const exportFiles = (cat, token, values, ids) => {
  return axios.get(
    cat
      ? `${API_URL}files/${cat}?ids=${ids}&all=1${
          values.column && values.search && !ids
            ? `&${values.column}=${values.search}`
            : ""
        }`
      : `${API_URL}files?ids=${ids}&all=1${
          values.column && values.search && !ids
            ? `&${values.column}=${values.search}`
            : ""
        }`,
    {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
  );
};
const getFileById = (id, token) => {
  return axios.get(API_URL + "file/" + id + "/edit", {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

const deleteFileById = (token, id) => {
  return axios.delete(API_URL + "file/" + id, {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

const updateFile = (values, token, id) => {
  return axios.post(API_URL + "file/" + id, values, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  });
};

const putcategory = (values, token) => {
  return axios.post(API_URL + "category", values, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  });
};

const deleteCategoryId = (token, id) => {
  return axios.delete(API_URL + "category/" + id, {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

const getCategoryById = (id, token) => {
  return axios.get(API_URL + "category/" + id + "/edit", {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};
const updateCategory = (values, token, id) => {
  return axios.post(API_URL + "category/" + id, values, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  });
};

const restoreCategoryId = (token, id) => {
  return axios.get(API_URL + "category/restore/" + id, {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

const deleteCategoryHardId = (token, id) => {
  return axios.get(API_URL + "category/hard_delete/" + id, {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

const getCardsLists = (token) => {
  return axios.get(API_URL + "cards", {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

const submitSYCForm = (values, token, signature) => {
  return axios.post(
    API_URL + "sygwebsite",
    {
      name: values.name,
      url: values.url,
      type: values.type,
      user_survey_form: values.survey,
      user_information_form: values.info,
      registration_page: values.register,
      expected_client_delivery_date: values.delivery_date,
      reference_site: values.reference,
      store_location: values.locations,
      color_scheme: values.scheme,
      logo: values.logo,
      additional_comments: values.comments,

      card_type: values.card,
      signature: signature,
    },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
  );
};

const submitSYCFormNew = (values, token, id = null) => {
  return id
    ? axios.post(API_URL + "sygwebsite/" + id, values, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      })
    : axios.post(API_URL + "sygwebsite", values, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });
};
const submitOTBForm = (values, token, id = null) => {
  return id
    ? axios.post(
        API_URL + "otbwebsite/" + id,
        values,

        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        },
      )
    : axios.post(
        API_URL + "otbwebsite",
        values,

        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        },
      );
};
const submitRegFormNew = (values, token, id = null) => {
  return id
    ? axios.post(API_URL + "regwebsite/" + id, values, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      })
    : axios.post(API_URL + "regwebsite", values, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });
};
const getSitesData = (siteType, token, values, limit, page) => {
  return axios.get(
    `${API_URL}${siteType}?limit=${limit}&page=${page}${
      values.column && values.search ? `&${values.column}=${values.search}` : ""
    }`,
    {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
  );
};

const exportSitesData = (siteType, token, ids, values) => {
  return axios.get(
    `${API_URL}${siteType}?ids=${ids}&all=1${
      values.column && values.search && !ids
        ? `&${values.column}=${values.search}`
        : ""
    }`,
    {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
  );
};

const markSiteCompleted = (token, id, type, message) => {
  return axios.post(
    API_URL + type + "/" + +id + "/completed",
    {
      message: message,
    },
    {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
  );
};

const markSiteDatabase = (token, id, type, values) => {
  return axios.post(
    API_URL + "database_connection/store",
    type === "otb"
      ? {
          name: values.name,
          website_id: id,
          website_type: type,
        }
      : {
          website_id: id,
          website_type: type,
          name: values.name,
          username: values.username,
          password: values.password,
          host: values.host,
        },
    {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
  );
};

const getSiteCreds = (siteType, token, id) => {
  return axios.get(`${API_URL}${siteType}/${id}/credentials`, {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

const updateSiteCreds = (values, token, AdminId, id, type) => {
  return axios.post(
    `${API_URL}${type}/update_password`,
    {
      admin_id: AdminId,
      password: values.search,
      id: id,
    },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
  );
};

const getSiteDetailsByIdType = (type, id, token) => {
  return axios.get(API_URL + `${type}/${id}/edit`, {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};
const getHolidays = (token, type) => {
  return axios.get(API_URL + `public_holiday?siteType=${type}`, {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};
const getOTBSitesListForSelect = (token) => {
  return axios.get(API_URL + `otbwebsite/v2`, {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};
const getSitesUsersData = (siteType, token, values, limit, page) => {
  return axios.get(
    `${API_URL}${siteType}/users?limit=${limit}&page=${page}${
      values.column && values.search ? `&${values.column}=${values.search}` : ""
    }`,
    {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
  );
};
const exportSitesUsersData = (siteType, token, ids, values) => {
  return axios.get(
    `${API_URL}${siteType}/users?ids=${ids}&all=1${
      values.column && values.search && !ids
        ? `&${values.column}=${values.search}`
        : ""
    }`,
    {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
  );
};
const getLoginAzureLink = (loginWith) => {
  return axios.get(
    `${API_URL}auth/${loginWith}`,

    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  );
};
const getAzureLoginUserInfo = (id, type) => {
  return axios.get(
    `${API_URL}verify/${type}/login/${id}`,

    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  );
};
const AdminListService = {
  loginUser,
  getLoginAzureLink,
  getAzureLoginUserInfo,
  recoverUser,
  setNewPassword,
  checkResetLink,
  getCategory,
  exportCategory,
  addUsers,
  getUsers,
  exportUsers,
  getUsersById,
  updateUser,
  updateProfile,
  deleteUsersById,
  putFile,
  getFiles,
  exportFiles,
  getFileById,
  deleteFileById,
  updateFile,
  putcategory,
  deleteCategoryId,
  getCategoryById,
  updateCategory,
  restoreCategoryId,
  deleteCategoryHardId,
  submitSYCForm,
  submitSYCFormNew,
  submitOTBForm,
  submitRegFormNew,
  getSitesData,
  exportSitesData,
  markSiteCompleted,
  markSiteDatabase,
  getSiteCreds,
  updateSiteCreds,
  getCardsLists,
  getSiteDetailsByIdType,
  getHolidays,
  getOTBSitesListForSelect,
  getSitesUsersData,
  exportSitesUsersData,
};

export default AdminListService;
